export default __webpack_public_path__ + "static/media/DavidCasarett.c715f805.jpg";